import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 早退日時
 */
export class LeaveDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): LeaveDateTime {
    return new LeaveDateTime(value);
  }

  /** ラベル日 */
  static get labelDate(): string {
    return '日付';
  }

  /** ラベル時間 */
  static get labelTime(): string {
    return '時刻';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
